

































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { AuditMessage, AuditMessageResource } from '@/api/auditmessages/';
import AuditDiffSheet from '@/components/auditmessages/AuditDiffSheet.vue';

@Component({
  computed: mapState(['fiId']),
  components: {
    AuditDiffSheet,
  },
})
export default class AuditMessageTable extends Vue {
    fiId!: string;

    headers: DataTableHeader[] = [
      { text: 'Time', value: 'time' },
      { text: 'User Name', value: 'userName' },
      { text: 'Page', value: 'api' },
      { text: 'Method', value: 'method' },
    ];

    footerProps: any = {
      'items-per-page-options': [{ value: -1, text: 'All' }, 20, 40, 60],
    };

    loading: boolean = false;

    showAuditDiffSheet: boolean = false;

    auditMessageResults: AuditMessage[] = [];

    selectedAuditMessage: AuditMessage = {} as AuditMessage;

    totalItems: number = 0;

    dataTablePagingOptions = {};

    @Inject('AuditMessageResource')
    auditMessageResource!: AuditMessageResource;

    @Watch('fiId')
    onFiChange() {
      this.auditMessageResults = [];
      this.getAuditMessages();
    }

    showErrorMessage(error: string) {
      const al = new Alert(error, NoticeClass.ERROR);
      al.setTimeout(5000);
      this.$store.dispatch('notices/add', al);
    }

    mounted() {
      this.getAuditMessages();
    }

    getAuditMessages() {
      this.loading = true;

      this.auditMessageResource.getAuditMessages(this.fiId)
        .then((result: AuditMessage[]) => {
          this.auditMessageResults = result;
          this.totalItems = result.length;
        }).catch((error: any) => {
          this.handleError(error);
        }).finally(() => {
          this.loading = false;
        });
    }

    handleError(error: any) {
      if (error.response.status !== 401) {
        if (error.response.status === 504) {
          this.showErrorMessage('The request timed out.');
        } else {
          this.showErrorMessage('An unexpected error occurred while attempting to perform the request.');
        }
      }
    }

    formatDateTime = (date: Date) => {
      if (date !== null) {
        const dateFormatOptions = {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
        };
        return new Date(date).toLocaleDateString('en-US', dateFormatOptions).replace(',', '');
      }
      return '';
    }

    showDiff(id: string) {
      this.selectedAuditMessage = this.auditMessageResults.filter((audit: AuditMessage) => audit.id === id)[0];
      this.showAuditDiffSheet = true;
    }

    friendlyNameMap: any = {
      '/qualification-summary': 'Qualification Summary',
      '/account-qualification-details': 'Consumer/Account Detail',
      '/qualification-details': 'Consumer/Account Detail',
      '/qual-override': 'Qualification Override',
      '/qual-override-creator': 'Qualification Override',
      '/reward-details': 'Consumer/Account Detail',
      '/incontrol-details': 'Consumer/Account Detail',
      '/reward-summary': 'Reward Summary',
      '/reward-summary-by-type': 'Reward Summary',
      '/tunes-summary': 'Tunes Summary',
      '/tunes-summary-report': 'Tunes Summary',
      '/tunes-summary-current': 'Tunes Summary',
      '/tunes-details': 'Consumer/Account Detail',
      '/cycle-validation-snapshot': 'Rewards Validation',
      '/cycle-validation-approval': 'Rewards Validation',
      '/s3key-download': 'Rewards Validation',
      '/cycle-validation-report': 'Rewards Validation',
      '/qual-override-report': 'Qualification Override',
      '/reports': 'Reports',
      '/audit': 'Audit Messages',
    };

    pathFragments = Object.keys(this.friendlyNameMap);

    getFriendlyName = (apiEndpoint: string) => {
      if (!apiEndpoint) {
        return '';
      }
      const matchingPathFragment = this.pathFragments.find(pathFragment => apiEndpoint.includes(pathFragment));
      if (matchingPathFragment) {
        return this.friendlyNameMap[matchingPathFragment];
      }
      return 'Unknown';
    };
}
